export default __webpack_public_path__ + "static/media/text-to-speech.e8ad8a5a01e28b2385a03697aff08714.svg";